class exports.Qbusers_Handler extends FullPageHandler
    init: () ->
        @sidebar_open = false
        @layoutUrl = 'backend/portal/qbusers/'
        @createDialog()

    afterLoadLayout: () ->
        self = this
        @openDialog()

        @dialog.find('.message_writer').message_writer()

        @dialog.find('.sel_qb_users').select2
            width: '500px'
            placeholder: 'Select...'

        @dialog.find('.sel_qb_users').bind 'change', () ->
            uid = $(this).data('uid')
            val = $(this).val()
            $.post 'backend/portal/qbusers/save-match', { uid: uid, qbid: val }, (response) ->
                self.dialog.find('.message_writer').message_writer(response.status.type, response.status.msg)
                if response.status.type is 'success'
                    self.dialog.find('.message_writer').message_writer('hide')

        @dialog.find('.btn-refresh').bind 'click', () =>
            @refresh()
